import React from 'react';

function EditUser() {
  return <div>EditUser</div>;
}

export default EditUser;
